<form [formGroup]="componentForm" (ngSubmit)="onSubmit()">
    <p-accordion [activeIndex]="isExpanded ? 0 : -1">
        <p-accordionTab>
            <ng-template pTemplate="header">
                <div class="accordion-header">
                    <div class="header-title">
                        <span>{{ translationKey | translate }}</span>
                    </div>
                    <div class="header-subtitle">
                        <span *ngIf="getHeaderSubtitle(componentForm.value).subtitleLeft"
                            [ngClass]="{ 'modified': isLeftSubtitleModified() }">
                            {{ 'LEFT' | translate}} {{ getHeaderSubtitle(componentForm.value).subtitleLeft }}
                        </span>
                        <span *ngIf="getHeaderSubtitle(componentForm.value).subtitleRight"
                            [ngClass]="{ 'modified': isRightSubtitleModified() }">
                            {{ 'RIGHT' | translate}} {{ getHeaderSubtitle(componentForm.value).subtitleRight }}
                        </span>
                    </div>
                </div>
            </ng-template>

            <div *ngIf="componentForm.disabled && disabledReason" class="disabled-warning">
                <mat-icon>warning</mat-icon>
                <span>{{ disabledReason }}</span>
            </div>

            <div *ngIf="!componentForm.disabled && warningMessage" class="disabled-warning limitation-warning">
                <mat-icon>info</mat-icon>
                <span>{{ warningMessage }}</span>
            </div>

            <div class="insole-component-display-container" [class.disabled-opacity]="componentForm.disabled">

                <!-- Show the image of the component -->
                <div class="insole-component-display-container">
                    <div class="insole-component-image">

                        <mat-button-toggle-group class="foot-selection" aria-label="Foot selection"
                            formControlName="footSelection" [hideSingleSelectionIndicator]="true">
                            <mat-button-toggle *ngFor="let footSelected of footSelectionOptions"
                                [value]="footSelected.value" [disabled]="footSelected.disabled"
                                (click)="changeFootSelected(footSelected.value, $event)">
                                {{ footSelected.translationKey | translate }}
                            </mat-button-toggle>
                        </mat-button-toggle-group>

                        <img mat-card-image style="height: 100px; width: auto; object-fit: contain; margin-top: 20px;"
                            [src]="imageUrl" alt="Product Image">
                    </div>
                </div>

                <!-- Show the info of the component -->
                <div class="component-info">


                    <div *ngIf="componentForm.value.footSelection && hasOptionsToFill">
                        <!-- Show only when left it's enabled -->
                        <div class="component-info" formGroupName="left"
                            *ngIf="(!componentForm.get('left').disabled && (componentForm.get('footSelection').value === 'left' || componentForm.get('footSelection').value === 'both'))">

                            <!-- Show radiobutton to select between different possible types  -->
                            <div *ngIf="typeSelectOptions">
                                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                    <mat-label>{{ 'SELECT_TYPE' | translate }}</mat-label>
                                    <mat-select formControlName="type">
                                        <mat-option *ngFor="let type of typeSelectOptions" [value]="type.value">
                                            {{ type.title }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div *ngIf="!medialLateralType && selectOptions">
                                <div class="flex gap-2 align-items-baseline column">

                                    <mat-form-field appearance="outline">
                                        <mat-label>
                                            {{
                                            title?.toLowerCase() === "morton's extension" ||
                                            title?.toLowerCase() === "arch reinforcement"
                                            ? ('LEFT_THICKNESS' | translate)
                                            : ('LEFT' | translate)
                                            }}
                                        </mat-label>

                                        <mat-select formControlName="selectedName"
                                            (selectionChange)="onSelectionChange('left', $event)">
                                            <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                {{ option.title }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'left' && !componentForm.get('left.selectedName')?.value && componentForm.get('left.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('left.selectedName')?.value && componentForm.get('left.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline"
                                    *ngIf="componentForm.get('left.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                    <input type="number" matInput formControlName="value">
                                </mat-form-field>
                            </div>

                            <div class="toggle-div" *ngIf="reversedBooleanOption">
                                <p-inputSwitch formControlName="reversed"></p-inputSwitch> <label>{{ 'LEFT_REVERSED' |
                                    translate }}</label>
                            </div>

                            <!-- Show if exists positon.heel -->
                            <div *ngIf="componentForm.get('left.position.heel')" formGroupName="position">
                                {{ 'LEFT' | translate }}
                                <div class="density-reduction-container">
                                    <div class="switch-item">
                                        <p-inputSwitch formControlName="heel"></p-inputSwitch>
                                        <label>{{ 'HEEL' | translate }}</label>
                                    </div>
                                    <div class="switch-item">
                                        <p-inputSwitch formControlName="medialArch"></p-inputSwitch>
                                        <label>{{ 'MEDIAL_ARCH' | translate }}</label>
                                    </div>
                                    <div class="switch-item">
                                        <p-inputSwitch formControlName="lateralArch"></p-inputSwitch>
                                        <label>{{ 'LATERAL_ARCH' | translate }}</label>
                                    </div>
                                    <div class="switch-item">
                                        <p-inputSwitch formControlName="metatarsal"></p-inputSwitch>
                                        <label>{{ 'METATARSAL' | translate }}</label>
                                    </div>
                                </div>
                            </div>

                            <!-- Has option to select lateral or medial per each foot, only one of them, not both -->
                            <div class="component-info" *ngIf="medialLateralType === 'unique'">

                                <mat-button-toggle-group class="lateral-medial" aria-label="Select position"
                                    [hideSingleSelectionIndicator]="true" formControlName="position"
                                    (change)="onChangeLateralMedialPositionValue('left', $event.value)" color="primary">
                                    <mat-button-toggle value="medial">{{ 'MEDIAL' | translate }}</mat-button-toggle>
                                    <mat-button-toggle value="lateral">{{ 'LATERAL' | translate }}</mat-button-toggle>
                                </mat-button-toggle-group>


                                <div *ngIf="componentForm.get('left.position')?.value === 'lateral'">

                                    <!-- If its forefotposting add balanced option and filled option-->
                                    <div class="mb-3 toggle-div"
                                        *ngIf="componentForm.get('left.lateral.balancedToRearfoot')"
                                        formGroupName="lateral">
                                        <p-inputSwitch formControlName="balancedToRearfoot"></p-inputSwitch>
                                        <label>{{ 'BALANCED_TO_REARFOOT' | translate }}</label>
                                    </div>

                                    <div class="mb-3 toggle-div" *ngIf="componentForm.get('left.lateral.filled')"
                                        formGroupName="lateral">
                                        <p-inputSwitch formControlName="filled"></p-inputSwitch> <label>{{ 'FILLED' |
                                            translate }}</label>
                                    </div>

                                    <!-- If has extrinsic in form add option option-->
                                    <div class="mb-3 toggle-div" *ngIf="componentForm.get('left.lateral.extrinsic')"
                                        formGroupName="lateral">
                                        <p-inputSwitch formControlName="extrinsic"></p-inputSwitch>
                                        <label>{{ 'EXTRINSIC' | translate }}</label>
                                    </div>

                                    <div class="column">
                                        <mat-form-field appearance="outline" formGroupName="lateral">
                                            <mat-label>{{ 'LEFT_LATERAL' | translate }}</mat-label>
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialValue('left', 'lateral', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <span class="error"
                                            *ngIf="componentForm.get('footSelection').value === 'left' && !componentForm.get('left.lateral.selectedName')?.value && componentForm.get('left.lateral.selectedName')?.enabled">
                                            Please select a value.
                                        </span>
                                        <span class="error"
                                            *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('left.lateral.selectedName')?.value && componentForm.get('left.lateral.selectedName')?.enabled">
                                            Please select a value.
                                        </span>
                                    </div>

                                    <mat-form-field appearance="outline" formGroupName="lateral"
                                        *ngIf="componentForm.get('left.lateral.selectedName')?.value === 'others'">
                                        <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                        <input type="number" matInput formControlName="value">
                                    </mat-form-field>
                                </div>

                                <div *ngIf="componentForm.get('left.position')?.value === 'medial'">

                                    <!-- If its forefotposting add balanced and filled options -->
                                    <div class="mb-3 toggle-div"
                                        *ngIf="componentForm.get('left.medial.balancedToRearfoot')"
                                        formGroupName="medial">
                                        <p-inputSwitch formControlName="balancedToRearfoot"></p-inputSwitch>
                                        <label>{{ 'BALANCED_TO_REARFOOT' | translate }}</label>
                                    </div>

                                    <div class="mb-3 toggle-div" *ngIf="componentForm.get('left.medial.filled')"
                                        formGroupName="medial">
                                        <p-inputSwitch formControlName="filled"></p-inputSwitch> <label>{{ 'FILLED' |
                                            translate }}</label>
                                    </div>

                                    <!-- If its forefotposting extrinsic option-->
                                    <div class="mb-3 toggle-div" *ngIf="componentForm.get('left.medial.extrinsic')"
                                        formGroupName="medial">
                                        <p-inputSwitch formControlName="extrinsic"></p-inputSwitch>
                                        <label>{{ 'EXTRINSIC' | translate }}</label>
                                    </div>

                                    <div class="column">
                                        <mat-form-field class="mt-2" appearance="outline" formGroupName="medial">
                                            <mat-label>{{ 'LEFT_MEDIAL' | translate }}</mat-label>
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialValue('left', 'medial', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <span class="error"
                                            *ngIf="componentForm.get('footSelection').value === 'left' && !componentForm.get('left.medial.selectedName')?.value && componentForm.get('left.medial.selectedName')?.enabled">
                                            {{ 'SELECT_A_VALUE' | translate }}
                                        </span>
                                        <span class="error"
                                            *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('left.medial.selectedName')?.value && componentForm.get('left.medial.selectedName')?.enabled">
                                            {{ 'SELECT_A_VALUE' | translate }}
                                        </span>
                                    </div>

                                    <mat-form-field appearance="outline" formGroupName="medial"
                                        *ngIf="componentForm.get('left.medial.selectedName')?.value === 'others'">
                                        <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                        <input type="number" matInput formControlName="value">
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- When is Flanges component, show Lateral and Medial with width and height -->
                            <div *ngIf="medialLateralType === 'multiple' && title == 'Flanges'">
                                <div class="column">
                                    <mat-form-field appearance="outline" formGroupName="lateral"
                                        class="bigger-form-field">
                                        <mat-label>{{ 'LEFT_LATERAL_WIDTH' | translate }}</mat-label>
                                        <div formGroupName="width">
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialWidthHeightValue('left', 'lateral', 'width', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" formGroupName="lateral"
                                        class="bigger-form-field">
                                        <mat-label>{{ 'LEFT_LATERAL_HEIGHT' | translate }}</mat-label>
                                        <div formGroupName="height">
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialWidthHeightValue('left', 'lateral', 'height', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </mat-form-field>

                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'left' && (!componentForm.get('left.lateral.width.selectedName')?.value || !componentForm.get('left.lateral.height.selectedName')?.value) && (componentForm.get('left.lateral.width.selectedName')?.enabled || componentForm.get('left.lateral.height.selectedName')?.enabled)">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && (!componentForm.get('left.lateral.width.selectedName')?.value || !componentForm.get('left.lateral.height.selectedName')?.value) && (componentForm.get('left.lateral.width.selectedName')?.enabled || componentForm.get('left.lateral.height.selectedName')?.enabled)">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline" formGroupName="lateral"
                                    *ngIf="componentForm.get('left.lateral.width.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'OTHER_WIDTH' | translate }}</mat-label>
                                    <div formGroupName="width">
                                        <input type="number" matInput formControlName="value">
                                    </div>
                                </mat-form-field>

                                <mat-form-field appearance="outline" formGroupName="lateral"
                                    *ngIf="componentForm.get('left.lateral.height.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'OTHER_HEIGHT' | translate }}</mat-label>
                                    <div formGroupName="height">
                                        <input type="number" matInput formControlName="value">
                                    </div>
                                </mat-form-field>

                                <div class="column">
                                    <mat-form-field class="mt-2" appearance="outline" formGroupName="medial"
                                        class="bigger-form-field">
                                        <mat-label>{{ 'LEFT_MEDIAL_WIDTH' | translate }}</mat-label>
                                        <div formGroupName="width">
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialWidthHeightValue('left', 'medial', 'width', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </mat-form-field>

                                    <mat-form-field class="mt-2" appearance="outline" formGroupName="medial"
                                        class="bigger-form-field">
                                        <mat-label>{{ 'LEFT_MEDIAL_HEIGHT' | translate }}</mat-label>
                                        <div formGroupName="height">
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialWidthHeightValue('left', 'medial', 'height', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </mat-form-field>

                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'left' && (!componentForm.get('left.medial.width.selectedName')?.value || !componentForm.get('left.medial.height.selectedName')?.value) && (componentForm.get('left.medial.width.selectedName')?.enabled || componentForm.get('left.medial.height.selectedName')?.enabled)">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && (!componentForm.get('left.medial.width.selectedName')?.value || !componentForm.get('left.medial.height.selectedName')?.value) && (componentForm.get('left.medial.width.selectedName')?.enabled || componentForm.get('left.medial.height.selectedName')?.enabled)">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline" formGroupName="medial"
                                    *ngIf="componentForm.get('left.medial.width.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'OTHER_WIDTH' | translate }}</mat-label>
                                    <div formGroupName="width">
                                        <input type="number" matInput formControlName="value">
                                    </div>
                                </mat-form-field>

                                <mat-form-field appearance="outline" formGroupName="medial"
                                    *ngIf="componentForm.get('left.medial.height.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'OTHER_HEIGHT' | translate }}</mat-label>
                                    <div formGroupName="height">
                                        <input type="number" matInput formControlName="value">
                                    </div>
                                </mat-form-field>
                            </div>

                            <!-- When is NOT Flanges component, show normal Lateral and Medial without width and height -->
                            <div *ngIf="medialLateralType === 'multiple' && title !== 'Flanges'">
                                <div class="column">
                                    <mat-form-field appearance="outline" formGroupName="lateral">
                                        <mat-label>{{ 'LEFT_LATERAL' | translate }}</mat-label>
                                        <mat-select formControlName="selectedName"
                                            (selectionChange)="onChangeLateralMedialValue('left', 'lateral', $event)">
                                            <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                {{ option.title }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'left' && !componentForm.get('left.lateral.selectedName')?.value && componentForm.get('left.lateral.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('left.lateral.selectedName')?.value && componentForm.get('left.lateral.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline" formGroupName="lateral"
                                    *ngIf="componentForm.get('left.lateral.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                    <input type="number" matInput formControlName="value">
                                </mat-form-field>

                                <div class="column">
                                    <mat-form-field class="mt-2" appearance="outline" formGroupName="medial">
                                        <mat-label>{{ 'LEFT_MEDIAL' | translate }}</mat-label>
                                        <mat-select formControlName="selectedName"
                                            (selectionChange)="onChangeLateralMedialValue('left', 'medial', $event)">
                                            <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                {{ option.title }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'left' && !componentForm.get('left.medial.selectedName')?.value && componentForm.get('left.medial.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('left.medial.selectedName')?.value && componentForm.get('left.medial.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline" formGroupName="medial"
                                    *ngIf="componentForm.get('left.medial.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                    <input type="number" matInput formControlName="value">
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Right Foot -->
                        <div class="component-info" formGroupName="right"
                            *ngIf="(!componentForm.get('right').disabled && (componentForm.get('footSelection').value === 'right' || componentForm.get('footSelection').value === 'both'))">

                            <div *ngIf="typeSelectOptions">
                                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                    <mat-label>{{ 'SELECT_TYPE' | translate }}</mat-label>
                                    <mat-select formControlName="type">
                                        <mat-option *ngFor="let type of typeSelectOptions" [value]="type.value">
                                            {{ type.title }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div *ngIf="!medialLateralType && selectOptions">
                                <div class="flex gap-2 align-items-baseline column">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ 'RIGHT' | translate }}</mat-label>
                                        <mat-select formControlName="selectedName"
                                            (selectionChange)="onSelectionChange('right', $event)">
                                            <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                {{ option.title }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'right' && !componentForm.get('right.selectedName')?.value && componentForm.get('right.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('right.selectedName')?.value && componentForm.get('right.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline"
                                    *ngIf="componentForm.get('right.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                    <input type="number" matInput formControlName="value">
                                </mat-form-field>

                                <div *ngIf="componentForm.errors?.['bothRequired'] && (componentForm.get('right.value').dirty || componentForm.get('left.value').dirty) "
                                    class="error">
                                    {{ 'VALUES_FOR_LEFT_AND_RIGHT_FOOT_ARE_REQUIRED' | translate }}
                                </div>
                            </div>

                            <div class="toggle-div" *ngIf="reversedBooleanOption">
                                <p-inputSwitch formControlName="reversed"></p-inputSwitch> <label>{{ 'RIGHT_REVERSED' |
                                    translate }}</label>
                            </div>

                            <div *ngIf="componentForm.get('right.position.heel')" formGroupName="position">
                                Right
                                <div class="density-reduction-container">
                                    <div class="switch-item">
                                        <p-inputSwitch formControlName="heel"></p-inputSwitch>
                                        <label>{{ 'HEEL' | translate }}</label>
                                    </div>
                                    <div class="switch-item">
                                        <p-inputSwitch formControlName="medialArch"></p-inputSwitch>
                                        <label>{{ 'MEDIAL_ARCH' | translate }}</label>
                                    </div>
                                    <div class="switch-item">
                                        <p-inputSwitch formControlName="lateralArch"></p-inputSwitch>
                                        <label>{{ 'LATERAL_ARCH' | translate }}</label>
                                    </div>
                                    <div class="switch-item">
                                        <p-inputSwitch formControlName="metatarsal"></p-inputSwitch>
                                        <label>{{ 'METATARSAL' | translate }}</label>
                                    </div>
                                </div>
                            </div>

                            <!-- Has option to select lateral or medial per each foot, only one of them, not both -->
                            <div class="component-info" *ngIf="medialLateralType === 'unique'">


                                <!-- Select the position of the component (medial or lateral) -->
                                <mat-button-toggle-group class="lateral-medial" aria-label="Select position"
                                    [hideSingleSelectionIndicator]="true" formControlName="position"
                                    (change)="onChangeLateralMedialPositionValue('right', $event.value)"
                                    color="primary">
                                    <mat-button-toggle value="medial">{{ 'MEDIAL' | translate }}</mat-button-toggle>
                                    <mat-button-toggle value="lateral">{{ 'LATERAL' | translate }}</mat-button-toggle>
                                </mat-button-toggle-group>

                                <div *ngIf="componentForm.get('right.position')?.value === 'lateral'">

                                    <!-- If its forefotposting add balanced and filled options -->
                                    <div class="mb-3 toggle-div"
                                        *ngIf="componentForm.get('right.lateral.balancedToRearfoot')"
                                        formGroupName="lateral">
                                        <p-inputSwitch formControlName="balancedToRearfoot"></p-inputSwitch>
                                        <label>{{ 'BALANCED_TO_REARFOOT' | translate }}</label>
                                    </div>

                                    <div class="mb-3 toggle-div" *ngIf="componentForm.get('right.lateral.filled')"
                                        formGroupName="lateral">
                                        <p-inputSwitch formControlName="filled"></p-inputSwitch> <label>{{ 'FILLED' |
                                            translate }}</label>
                                    </div>

                                    <!-- If has extrinsic in form add option option-->
                                    <div class="mb-3 toggle-div" *ngIf="componentForm.get('right.lateral.extrinsic')"
                                        formGroupName="lateral">
                                        <p-inputSwitch formControlName="extrinsic"></p-inputSwitch>
                                        <label>{{ 'EXTRINSIC' | translate }}</label>
                                    </div>

                                    <div class="column">
                                        <mat-form-field appearance="outline" formGroupName="lateral">
                                            <mat-label>{{ 'RIGHT_LATERAL' | translate }}</mat-label>
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialValue('right', 'lateral', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <span class="error"
                                            *ngIf="componentForm.get('footSelection').value === 'right' && !componentForm.get('right.lateral.selectedName')?.value && componentForm.get('right.lateral.selectedName')?.enabled">
                                            Please select a value.
                                        </span>
                                        <span class="error"
                                            *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('right.lateral.selectedName')?.value && componentForm.get('right.lateral.selectedName')?.enabled">
                                            Please select a value.
                                        </span>
                                    </div>

                                    <mat-form-field appearance="outline" formGroupName="lateral"
                                        *ngIf="componentForm.get('right.lateral.selectedName')?.value === 'others'">
                                        <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                        <input type="number" matInput formControlName="value">
                                    </mat-form-field>
                                </div>

                                <div *ngIf="componentForm.get('right.position')?.value === 'medial'">

                                    <!-- If its forefotposting add balanced and filled option-->
                                    <div class="mb-3 toggle-div"
                                        *ngIf="componentForm.get('right.medial.balancedToRearfoot')"
                                        formGroupName="medial">
                                        <p-inputSwitch formControlName="balancedToRearfoot"></p-inputSwitch>
                                        <label>{{ 'BALANCED_TO_REARFOOT' | translate }}</label>
                                    </div>

                                    <div class="mb-3 toggle-div" *ngIf="componentForm.get('right.medial.filled')"
                                        formGroupName="medial">
                                        <p-inputSwitch formControlName="filled"></p-inputSwitch> <label>{{ 'FILLED' |
                                            translate }}</label>
                                    </div>

                                    <!-- If has extrinsic in form add option option-->
                                    <div class="mb-3 toggle-div" *ngIf="componentForm.get('right.medial.extrinsic')"
                                        formGroupName="medial">
                                        <p-inputSwitch formControlName="extrinsic"></p-inputSwitch>
                                        <label>{{ 'EXTRINSIC' | translate }}</label>
                                    </div>

                                    <div class="column">
                                        <mat-form-field appearance="outline" formGroupName="medial">
                                            <mat-label>{{ 'RIGHT_MEDIAL' | translate }}</mat-label>
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialValue('right', 'medial', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <span class="error"
                                            *ngIf="componentForm.get('footSelection').value === 'right' && !componentForm.get('right.medial.selectedName')?.value && componentForm.get('right.medial.selectedName')?.enabled">
                                            Please select a value.
                                        </span>
                                        <span class="error"
                                            *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('right.medial.selectedName')?.value && componentForm.get('right.medial.selectedName')?.enabled">
                                            Please select a value.
                                        </span>
                                    </div>

                                    <mat-form-field appearance="outline" formGroupName="medial"
                                        *ngIf="componentForm.get('right.medial.selectedName')?.value === 'others'">
                                        <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                        <input type="number" matInput formControlName="value">
                                    </mat-form-field>
                                </div>
                            </div>

                            <!-- When is Flanges component, show Lateral and Medial with width and height -->
                            <div *ngIf="medialLateralType === 'multiple' && title == 'Flanges'">
                                <div class="column">
                                    <mat-form-field appearance="outline" formGroupName="lateral"
                                        class="bigger-form-field">
                                        <mat-label>{{ 'RIGHT_LATERAL_WIDTH' | translate }}</mat-label>
                                        <div formGroupName="width">
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialWidthHeightValue('right', 'lateral', 'width', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" formGroupName="lateral"
                                        class="bigger-form-field">
                                        <mat-label>{{ 'RIGHT_LATERAL_HEIGHT' | translate }}</mat-label>
                                        <div formGroupName="height">
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialWidthHeightValue('right', 'lateral', 'height', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </mat-form-field>

                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'right' && (!componentForm.get('right.lateral.width.selectedName')?.value || !componentForm.get('right.lateral.height.selectedName')?.value) && (componentForm.get('right.lateral.width.selectedName')?.enabled || componentForm.get('right.lateral.height.selectedName')?.enabled)">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && (!componentForm.get('right.lateral.width.selectedName')?.value || !componentForm.get('right.lateral.height.selectedName')?.value) && (componentForm.get('right.lateral.width.selectedName')?.enabled || componentForm.get('right.lateral.height.selectedName')?.enabled)">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline" formGroupName="lateral"
                                    *ngIf="componentForm.get('right.lateral.width.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'OTHER_WIDTH' | translate }}</mat-label>
                                    <input type="number" matInput formControlName="value">
                                </mat-form-field>

                                <mat-form-field appearance="outline" formGroupName="lateral"
                                    *ngIf="componentForm.get('right.lateral.height.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'OTHER_HEIGHT' | translate }}</mat-label>
                                    <input type="number" matInput formControlName="value">
                                </mat-form-field>

                                <div class="column">
                                    <mat-form-field appearance="outline" formGroupName="medial"
                                        class="bigger-form-field">
                                        <mat-label>{{ 'RIGHT_MEDIAL_WIDTH' | translate }}</mat-label>
                                        <div formGroupName="width">
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialWidthHeightValue('right', 'medial', 'width', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" formGroupName="medial"
                                        class="bigger-form-field">
                                        <mat-label>{{ 'RIGHT_MEDIAL_HEIGHT' | translate }}</mat-label>
                                        <div formGroupName="height">
                                            <mat-select formControlName="selectedName"
                                                (selectionChange)="onChangeLateralMedialWidthHeightValue('right', 'medial', 'height', $event)">
                                                <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                    {{ option.title }}
                                                </mat-option>
                                            </mat-select>
                                        </div>
                                    </mat-form-field>

                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'right' && (!componentForm.get('right.medial.width.selectedName')?.value || !componentForm.get('right.medial.height.selectedName')?.value) && (componentForm.get('right.medial.width.selectedName')?.enabled || componentForm.get('right.medial.height.selectedName')?.enabled)">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && (!componentForm.get('right.medial.width.selectedName')?.value || !componentForm.get('right.medial.height.selectedName')?.value) && (componentForm.get('right.medial.width.selectedName')?.enabled || componentForm.get('right.medial.height.selectedName')?.enabled)">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline" formGroupName="medial"
                                    *ngIf="componentForm.get('right.medial.width.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'OTHER_WIDTH' | translate }}</mat-label>
                                    <div formGroupName="width">
                                        <input type="number" matInput formControlName="value">
                                    </div>
                                </mat-form-field>

                                <mat-form-field appearance="outline" formGroupName="medial"
                                    *ngIf="componentForm.get('right.medial.height.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'OTHER_HEIGHT' | translate }}</mat-label>
                                    <div formGroupName="height">
                                        <input type="number" matInput formControlName="value">
                                    </div>
                                </mat-form-field>
                            </div>

                            <!-- When is NOT Flanges component, show normal Lateral and Medial without width and height -->
                            <div *ngIf="medialLateralType === 'multiple' && title !== 'Flanges'">
                                <div class="column">
                                    <mat-form-field appearance="outline" formGroupName="lateral">
                                        <mat-label>{{ 'RIGHT_LATERAL' | translate }}</mat-label>
                                        <mat-select formControlName="selectedName"
                                            (selectionChange)="onChangeLateralMedialValue('right', 'lateral', $event)">
                                            <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                {{ option.title }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'right' && !componentForm.get('right.lateral.selectedName')?.value && componentForm.get('right.lateral.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('right.lateral.selectedName')?.value && componentForm.get('right.lateral.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline" formGroupName="lateral"
                                    *ngIf="componentForm.get('right.lateral.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                    <input type="number" matInput formControlName="value">
                                </mat-form-field>

                                <div class="column">
                                    <mat-form-field appearance="outline" formGroupName="medial">
                                        <mat-label>{{ 'RIGHT_MEDIAL' | translate }}</mat-label>
                                        <mat-select formControlName="selectedName"
                                            (selectionChange)="onChangeLateralMedialValue('right', 'medial', $event)">
                                            <mat-option *ngFor="let option of selectOptions" [value]="option.value">
                                                {{ option.title }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'right' && !componentForm.get('right.medial.selectedName')?.value && componentForm.get('right.medial.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                    <span class="error"
                                        *ngIf="componentForm.get('footSelection').value === 'both' && !componentForm.get('right.medial.selectedName')?.value && componentForm.get('right.medial.selectedName')?.enabled">
                                        {{ 'SELECT_A_VALUE' | translate }}
                                    </span>
                                </div>

                                <mat-form-field appearance="outline" formGroupName="medial"
                                    *ngIf="componentForm.get('right.medial.selectedName')?.value === 'others'">
                                    <mat-label>{{ 'SPECIFY_OTHER_VALUE' | translate }}</mat-label>
                                    <input type="number" matInput formControlName="value">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>
</form>